import { render, staticRenderFns } from "./SystemMessageOverview.vue?vue&type=template&id=0954dd48&scoped=true"
import script from "./SystemMessageOverview.vue?vue&type=script&lang=ts"
export * from "./SystemMessageOverview.vue?vue&type=script&lang=ts"
import style0 from "./SystemMessageOverview.vue?vue&type=style&index=0&id=0954dd48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954dd48",
  null
  
)

export default component.exports